/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  Suspense,
  lazy,
  useState,
  useEffect,
  useRef,
  useContext,
} from "react";
import { Route, Routes, BrowserRouter as Router } from "react-router-dom";
import NavBar from "./navBar/NavBar";
import LoadingComponent from "../global/LoadingComponent";
import Sidebar from "./Sidebar";
import EventBookingForm from "../pages/eventBooking/EventBookingForm";
import appContext from "../../context/app/appContext";

// const Home = lazy(() => import("../pages/home/Home"));
const Event = lazy(() => import("../pages/event/Event"));
const Admin = lazy(() => import("../pages/admin/Admin"));
// const HomePage = lazy(() => import("../pages/homePage/HomePage"));
const Home = lazy(() => import("../pages/home/Home"));
const ViewEvent = lazy(() => import("../pages/viewEvent/ViewEvent"));
const EditEvent = lazy(() => import("../pages/editEvent/EditEvent"));
const SisEntry = lazy(() => import("../pages/sisEntry/SisEntry"));
const CalendarViewer = lazy(() =>
  import("../pages/calendarViewer/CalendarViewer")
);
const EventSearch = lazy(() => import("../pages/eventSearch/EventSearch"));

const AppContainer = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isPinned, setIsPinned] = useState(false);
  const sidebarRef = useRef(null);

  const { dbUser } = useContext(appContext);

  useEffect(() => {
    const checkScreenSize = () => {
      if (window.innerWidth < 768) {
        setIsSidebarOpen(false);
        setIsPinned(false);
      } else {
        setIsSidebarOpen(false);
      }
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  // useEffect(() => {
  //   const pinned = localStorage.getItem("sidebarPinned") === "true";
  //   setIsPinned(pinned);
  // }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  const togglePin = () => {
    setIsPinned((prev) => {
      localStorage.setItem("sidebarPinned", !prev);
      return !prev;
    });
  };

  const handleClickOutside = (event) => {
    if (
      sidebarRef.current &&
      !sidebarRef.current.contains(event.target) &&
      !isPinned
    ) {
      setIsSidebarOpen(false);
    }
  };

  useEffect(() => {
    if (isSidebarOpen && !isPinned) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isSidebarOpen, isPinned]);
  if (!dbUser) {
    return <LoadingComponent message="Signing in..." />;
  } else {
    return (
      <div className="flex h-screen transition-all duration-300">
        <Router>
          <Sidebar
            ref={sidebarRef}
            isSidebarOpen={isSidebarOpen}
            isPinned={isPinned}
            toggleSidebar={toggleSidebar}
            togglePin={togglePin}
          />
          {/* Main Content Adjusts Dynamically */}
          <div
            className={`flex flex-col flex-grow p-2 transition-all duration-300 ${
              isSidebarOpen ? "ml-64" : "ml-0"
            }`}
          >
            <Suspense fallback={<LoadingComponent message="loading..." />}>
              <NavBar
                isSidebarOpen={isSidebarOpen}
                toggleSidebar={toggleSidebar}
              />
              <Routes>
                <Route exact path="/" element={<Home />} />
                <Route exact path="/event/:eventId" element={<Event />} />
                <Route exact path="/admin" element={<Admin />} />
                <Route
                  exact
                  path="/eventBooking"
                  element={<EventBookingForm />}
                />
                <Route
                  exact
                  path="/viewEvent/:event_id"
                  element={<ViewEvent />}
                />
                <Route
                  exact
                  path="/editEvent/:event_id"
                  element={<EditEvent />}
                />
                <Route
                  exact
                  path="/tassEntry/:event_id"
                  element={<SisEntry />}
                />
                <Route exact path="/calendar" element={<CalendarViewer />} />
                <Route exact path='/calendarSearch' element={<EventSearch />} />
              </Routes>
            </Suspense>
          </div>
        </Router>
      </div>
    );
  }
};

export default AppContainer;
